enum CreditRatingAgencyEnum {
  SP = 'S&P',
  Moodys = 'Moody\'s',
  Fitch = 'Fitch',
}

export default CreditRatingAgencyEnum;
